/**
 * Determines if this is a MooveOn direct order (Croatia + MooveOn payment).
 * When true, dealer selection is skipped and email goes only to MooveOn.
 *
 * @param {string} siteHandle
 * @param {string|undefined} paymentHandle - the field_paymentOption_paymentHandle value
 * @returns {boolean}
 */
export function checkIsMooveOnDirectOrder(siteHandle, paymentHandle) {
    return siteHandle === 'mgMotorsCroatia' && paymentHandle === 'mooveon';
}
